module.exports = __webpack_public_path__ + "static/img/154.da1fdb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/医疗健康/154.png
// module id = YS+E
// module chunks = 1